import Logo from "../assets/logo_white.png";

import us from "../assets/us.png";
import ge from "../assets/ge.png";
import nl from "../assets/nl.png";

function Footer({clickPopup}) {
    return ( 
        <>
            <footer>
                <div class="container-lg">
                    <a class="navbar-brand" href="#">
                        <img src={Logo} alt="logo" loading="lazy"/>
                    </a>

                    <ul class="link-items linked-wrapper">
                        <li class="link-item linked">
                            <a class="nav-link active" aria-current="page" href="./">main page</a>
                        </li>
                        <li class="link-item linked">
                            <a class="nav-link" href="/about">about us</a>
                        </li>
                        <li class="link-item linked">
                            <a class="nav-link" href="/models">our cases</a>
                        </li>
                        <li class="link-item linked">
                            <a class="nav-link" href="/blog">our blog</a>
                        </li>
                    </ul>

                    <ul class="link-items">
                        <li class="link-item">
                            <a class="nav-link active" aria-current="page" href="/contacts">Contacts</a>
                        </li>
                        <li class="link-item main-under contacts-footer">
                            +38 888 888 888
                        </li>
                        <li class="link-item contacts-footer">
                            <a href="mailto:contact@onlyglance.com">contact@onlyglance.com</a>
                        </li>
                    </ul>

                    <ul class="link-items">
                        <button className="main-button" onClick={clickPopup}>
                            Enroll now
                        </button>
                        <div className="flex-row">
                            <li class="link-item underscored">
                                <a href="/terms">Terms of use</a>
                            </li>
                            <li class="link-item underscored">
                                <a href="/privacy">Privacy Policy</a>
                            </li>
                        </div>
                    </ul>

                    <ul className="switchers">
                        <li className="switcher">
                            <a href="/us"><img src={us} /></a>
                        </li>
                    </ul>

                </div>

                <hr />

                <div className="container-lg flex-box">
                    <div className="copyright">
                        © All rights reserved, 2021 | onlyglance.com
                    </div>
                    <div className="copyright">
                        <a href="https://wolfpack-entertainment.net/">Wolfpack-entertainment.net</a>
                    </div>
                </div>
            </footer>
        </>
     );
}

export default Footer;